

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import HumansStoreModule from '../store/HumansStoreModule'

import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { InputEvent, ClickEvent, PageLayout, ContainerLayout, LinearLayout, BaseHeading, BaseContent, BaseDateText, BaseText, BaseButton, BaseTable, BaseIcon, BaseAutocompleteSelect, BaseTag, BaseCard } from '@revas/reef'

import AppNavigationTabs from '@/components/shared/AppNavigationTabs.vue'

import Organization from '@revas/kadra-library/src/revas/vue/vuex/models/Organization'

import { ResourceContact } from '../store/models/pagination/ListResourcesPagination'
import ListResourcesActionPayload from '../store/models/resource/ListResourcesActionPayload'

import { Contact } from '@/models'
import SearchContactActionPayload from '../store/models/contact/SearchContactActionPayload'

import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'
import { createUtcIsoDate, addDays } from '../store/helper'
import Page from '../store/models/pagination/Page'

@Component({
  components: {
    PageLayout,
    ContainerLayout,
    LinearLayout,
    BaseHeading,
    BaseContent,
    BaseButton,
    BaseTable,
    BaseAutocompleteSelect,
    BaseTag,
    BaseIcon,
    BaseDateText,
    BaseText,
    BaseCard,
    AppNavigationTabs
  }
})
export default class VResourceCollection extends Vue {
  @Prop() readonly humansStoreModule!: HumansStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly routeName!: string

  get resourceContacts (): ResourceContact[] {
    const a = this.humansStoreModule.currentResourcesItems
    if (a !== null) {
      return a
    } else {
      return []
    }
  }

  //
  //
  // Table
  get tableTemplate () {
    return [
      {
        key: 'name',
        label: this.i18n.t('shared.name')
      },
      {
        key: 'email',
        label: this.i18n.t('shared.email')
      },
      {
        key: 'phone',
        label: this.i18n.t('shared.phone')
      },
      {
        key: 'effectiveFrom',
        label: this.i18n.t('humans.valid_from')
      },
      {
        key: 'effectiveTo',
        label: this.i18n.t('humans.valid_to')
      }
    ]
  }

  onHumanClick ($event: ClickEvent<ResourceContact>) {
    if ($event.value) {
      this.goToResourceEditor($event.value.id)
    }
  }

  //
  //
  // Contact filter

  get selectedContact () {
    return this.humansStoreModule.currentSelectedSearchContact
  }

  @Watch('selectedContact')
  onContactSelected () {
    const firstPage: Page<ResourceContact> = new Page()
    firstPage.number = 1
    firstPage.search = this.searchFilter
    this.listResources(firstPage)
  }

  resetContactSearchFilter () {
    this.humansStoreModule.resetContactSearchFilter()
  }

  get searchedContactId (): string {
    if (this.selectedContact === null) {
      return ''
    } else {
      return this.selectedContact.id
    }
  }

  private isUserTyping = false

  @Watch('isUserTyping')
  onIsUserTyping (value: boolean) {
    if (!value) {
      this.searchContact()
    }
  }

  async searchContact () {
    const payload = new SearchContactActionPayload(this.contactSearchFilter, '')
    await this.humansStoreModule.asyncSearchResources(payload)
  }

  private contactSearchFilter = ''
  private debounce = 0

  @Watch('contactSearchFilter')
  onContactSearchFilter () {
    this.debounce = window.setTimeout(() => {
      this.isUserTyping = false
    }, 1000)
  }

  async onContactSearchInput ($event: InputEvent<string>) {
    if ($event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.isUserTyping = true
    this.contactSearchFilter = $event.value
  }

  get resourcesSearchedByName (): ResourceContact[] {
    const c = this.humansStoreModule.resourcesSearchedByName
    if (c === null) {
      return []
    } else {
      return c
    }
  }

  selectContact ($event: InputEvent<ResourceContact>) {
    if ($event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.router.push({
      name: 'humans.RESOURCE_EDITOR.$NAME',
      params: {
        resourceId: $event.value.id
      }
    })
  }

  onContactRemove () {
    this.humansStoreModule.resetContactSearchFilter()
    this.contactSearchFilter = ''
  }

  //
  //
  // Pagination

  get searchFilter (): string {
    if (this.selectedContact !== null) {
      return `ge[effectiveTo]=${this.todayUtcIsoDate}&eq[contactId]=${this.searchedContactId}`
    } else {
      return `ge[effectiveTo]=${this.todayUtcIsoDate}`
    }
  }

  private todayUtcIsoDate = createUtcIsoDate(addDays(new Date(), 1))

  created () {
    const firstPage = new Page<ResourceContact>()
    firstPage.number = 1
    firstPage.search = this.searchFilter
    this.listResources(firstPage)
  }

  get currentPage (): number {
    return this.humansStoreModule.currentResourcesPage
  }

  get hasNextPage (): boolean {
    return this.humansStoreModule.currentResourcesHasNextPage
  }

  onChangePreviousPage () {
    const page = new Page<ResourceContact>()
    page.number = this.currentPage - 1
    page.search = this.searchFilter
    this.listResources(page)
  }

  onChangeNextPage () {
    const page = new Page<ResourceContact>()
    page.number = this.currentPage + 1
    page.search = this.searchFilter
    this.listResources(page)
  }

  async listResources (page: Page<ResourceContact>) {
    const payload = new ListResourcesActionPayload(page)
    await this.humansStoreModule.asyncListResources(payload)
  }

  //
  //
  // Navigation

  get organization (): Organization {
    const o = this.coreStoreModule.activeUserOrganization
    if (o !== null) {
      return o
    } else {
      return new Organization()
    }
  }

  goToCreateWorkSchedule () {
    this.router.push({
      name: 'humans.WORK_SCHEDULE_EDITOR.$NAME',
      params: {
        resourceId: '-',
        workScheduleId: '-'
      }
    })
  }

  goToResourceEditor (resourceId: string) {
    this.router.push({
      name: 'humans.RESOURCE_EDITOR.$NAME',
      params: {
        resourceId: resourceId
      }
    })
  }
}
